import React, { Component, Fragment } from 'react';
import { Alert, Button, Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Mutation, withApollo } from 'react-apollo';
import IngredientTypeText from '~/components/ingredientTypeText/ingredientTypeText';

export const archiveIngredientMutation = gql`
  mutation archiveIngredient($id: Int!) {
    archiveIngredient(id: $id) {
      id
    }
  }
`;

export class IngredientArchive extends Component {
  state = {
    isOpen: false,
    submitting: false,
    error: null
  };

  setError = error => {
    this.setState({ error });
  };

  setSubmitting = submitting => {
    this.setState({ submitting });
  };

  onToggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  renderNopeModalInner = () => {
    // You can't delete an ingredient if it has products
    const { products, type } = this.props.ingredient;

    return (
      <Fragment>
        <ModalHeader toggle={this.onToggle}>Cannot archive</ModalHeader>
        <ModalBody>
          <p className="mb3">
            You can't archive these <IngredientTypeText type={type} /> as some products have this as an ingredient.
            You'll need to remove it from these products before you can archive:
          </p>
          <ul className="mb0">
            {products.map(({ product }) => (
              <li key={product.id}>{product.name}</li>
            ))}
          </ul>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.onToggle}>
            Ok
          </Button>{' '}
        </ModalFooter>
      </Fragment>
    );
  };

  renderConfirmationModalInner = () => {
    const { client, ingredient, history } = this.props;
    const { name, type } = ingredient;
    const { submitting, error } = this.state;
    return (
      <Mutation mutation={archiveIngredientMutation}>
        {archiveIngredient => (
          <Fragment>
            <ModalHeader toggle={this.onToggle}>Are you sure?</ModalHeader>
            <ModalBody>
              {error && <Alert color="danger">{error}</Alert>}
              Are you sure you want to archive the <IngredientTypeText type={type} /> <em>{name}</em>?
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={this.onToggle}>
                Cancel
              </Button>{' '}
              <Button
                data-qa="ingredient-archive-ok"
                disabled={submitting}
                color="primary"
                onClick={async () => {
                  try {
                    this.setSubmitting(true);
                    await archiveIngredient({
                      variables: {
                        id: ingredient.id
                      }
                    });
                    // Clear cache
                    client.resetStore();
                    history.push(`/ingredients?archived=${name}`);
                  } catch (err) {
                    this.setSubmitting(false);
                    this.setError('An unknown error occured');
                  }
                }}
              >
                Archive
              </Button>
            </ModalFooter>
          </Fragment>
        )}
      </Mutation>
    );
  };

  render() {
    const { className, ingredient } = this.props;

    if (!ingredient) {
      // In some cases where ingredient comes though asyncronously, there is a chance that the ingredient
      // does not exist yet. If that is the case, don't render anything
      return null;
    }

    return (
      <Fragment>
        <Button data-qa="ingredient-archive" className={className} color="danger" outline onClick={this.onToggle}>
          Archive
        </Button>
        <Modal isOpen={this.state.isOpen} toggle={this.onToggle}>
          {ingredient.products.length ? this.renderNopeModalInner() : this.renderConfirmationModalInner()}
        </Modal>
      </Fragment>
    );
  }
}

export default withRouter(withApollo(IngredientArchive));



// WEBPACK FOOTER //
// ./src/containers/ingredientArchive/ingredientArchive.jsx